import { baseUrl, GET, POST, PUT, DELETE, CreateAuthRequest, makeUrlGET } from './constants';

const urlModule = baseUrl + "admin/";

export const apiReiniciarFolios = async (body) => {
    let url = urlModule + "folio";
    let request = await CreateAuthRequest(POST, body, true);

    return fetch(url, request)
        .then(response => response.json())
}

export const apiGetDatoTecnico = async (obj) => {
    let url = urlModule + "dato?" + makeUrlGET(obj);
    let request = await CreateAuthRequest(GET, null, true);

    return fetch(url, request)
        .then(response => response.json())
}

export const apiCreateDatoTecnico = async (body) => {
    let url = urlModule + "dato";
    let request = await CreateAuthRequest(POST, body, true);

    return fetch(url, request)
        .then(response => response.json())
}

export const apiDeleteDatoTecnico = async (body) => {
    let url = urlModule + "dato";
    let request = await CreateAuthRequest(DELETE, body, true);

    return fetch(url, request)
        .then(response => response.json())
}

export const apiGetActCajas = async (obj) => {
    let url = urlModule + "caja?" + makeUrlGET(obj);
    let request = await CreateAuthRequest(GET, null, true);

    return fetch(url, request)
        .then(response => response.json())
}

export const apiDeleteActCajas = async (body) => {
    let url = urlModule + "caja";
    let request = await CreateAuthRequest(DELETE, body, true);

    return fetch(url, request)
        .then(response => response.json())
}

export const apiCreateActCajas = async (body) => {
    let url = urlModule + "caja";
    let request = await CreateAuthRequest(POST, body, true);

    return fetch(url, request)
        .then(response => response.json())
}